/* Keep a consented Meta click identifier with the Shopify cart for order reconciliation. */
(() => {
  const storageKey = 'msp_meta_click_v1';
  const maxAgeMs = 7 * 24 * 60 * 60 * 1000;
  const params = new URLSearchParams(window.location.search);
  const clickId = params.get('fbclid');
  const validClickId = clickId && /^[A-Za-z0-9._-]{8,512}$/.test(clickId) ? clickId : null;
  const click = validClickId ? {
    id: validClickId,
    at: Date.now(),
    campaign: (params.get('utm_campaign') || '').slice(0, 128),
    ad: (params.get('utm_content') || '').slice(0, 128),
    source: (params.get('utm_source') || '').slice(0, 64),
  } : null;

  function readStoredClick() {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (stored && typeof stored.id === 'string' &&
          /^[A-Za-z0-9._-]{8,512}$/.test(stored.id) &&
          Number.isFinite(stored.at) && stored.at <= Date.now() &&
          Date.now() - stored.at <= maxAgeMs) return stored;
    } catch (_) { /* Storage can be disabled by the browser. */ }
    return null;
  }

  function cartAttributes(saved) {
    return {
      __meta_fbclid: saved ? saved.id : '',
      __meta_click_at: saved ? new Date(saved.at).toISOString() : '',
      __meta_campaign: saved ? saved.campaign : '',
      __meta_ad: saved ? saved.ad : '',
      __meta_source: saved ? saved.source : '',
    };
  }

  function updateCart(saved) {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes(saved) }),
    }).then((response) => {
      if (!response.ok) console.warn('Meta order attribution could not save cart attributes.');
    }).catch(() => console.warn('Meta order attribution could not reach the cart.'));
  }

  function syncWithConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed()) {
      let hadClick = false;
      try { hadClick = !!localStorage.getItem(storageKey); } catch (_) { /* Storage can be disabled. */ }
      try { localStorage.removeItem(storageKey); } catch (_) { /* Storage can be disabled. */ }
      if (hadClick) updateCart(null);
      return;
    }
    const saved = readStoredClick();
    const active = click || saved;
    if (active) {
      try { localStorage.setItem(storageKey, JSON.stringify(active)); } catch (_) { /* Cart still receives the click. */ }
      updateCart(active);
    } else {
      let hadClick = false;
      try { hadClick = !!localStorage.getItem(storageKey); } catch (_) { /* Storage can be disabled. */ }
      if (hadClick) {
        try { localStorage.removeItem(storageKey); } catch (_) { /* Storage can be disabled. */ }
        updateCart(null);
      }
    }
  }

  document.addEventListener('visitorConsentCollected', syncWithConsent);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncWithConsent();
    });
  } else if (window.Shopify?.customerPrivacy) {
    syncWithConsent();
  }
})();
